import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const WrapperField = styled.div`
  display: flex;
  gap: 10px;
`

export const WrapperIcon = styled.div`
  display: flex;
  align-items: center;

  margin-right: 10px;
`
export const DocumentTypeWrapper = styled.div`
  width: 90px;
`

export const WrapperButton = styled.div`
  button {
    width: 100%;
  }
`

export const QuantityRadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`
